import React from 'react';

const ConversationList = ({ conversations, openChat, notifications, currentUserEmail }) => {
  return (
    <div className="h-[calc(100vh-150px)] overflow-y-auto">
      {conversations?.map((chat) => {
        const otherParticipant = chat?.participants?.find((p) => p !== currentUserEmail);
        const lastMessage = chat?.messages?.[chat.messages.length - 1]?.text || "No messages yet";

        return (
          <div
            key={chat._id}
            onClick={() => openChat(chat)}
            className={`cursor-pointer px-4 py-3 hover:bg-gray-100 border-b border-gray-200 ${
              notifications[chat._id] ? 'bg-gray-50 font-semibold' : ''
            }`}
          >
            <div className="flex justify-between items-center">
              <span className="text-sm">{otherParticipant}</span>
              {notifications[chat._id] && (
                <span className="text-xs bg-red-500 text-white px-2 py-0.5 rounded-full">
                  {notifications[chat._id]}
                </span>
              )}
            </div>
            <div className="text-xs text-gray-500 truncate mt-1">{lastMessage}</div>
          </div>
        );
      })}
    </div>
  );
};

export default ConversationList;